import $ from 'jquery';
import { addAdminLoginAnnouncement } from '../../announcements';
import { checkOrgStatus } from '~src/utils';
import { initAnnunciFunebri } from '~src/sidebar/annunciFunebri/initAnnunciFunebri';
import { isLoggedUserGlobalEditor, isUserAuthorized } from '~src/user';
import { initSidebarProfile } from '../../sidebar-profile';
import { addOrgDataToNavbar } from '../../navbar';
import { initAnalytics, initSalesIqChat } from '~src/tracking';
import { shouldRedirectToProfiler } from '~src/user';
import { initBrowsersManagement } from '~src/initBrowsersManagement';
import initReferralLinks from '~src/referral/initReferralLinks';

export const commonMiddleware = async () => {
  $('body').removeClass('dashboard dashboard-sidebar-open');

  const isGlobalEditor = await isLoggedUserGlobalEditor();
  if (isGlobalEditor) {
    addAdminLoginAnnouncement();
  }

  initBrowsersManagement();

  await initAnalytics();
  await checkOrgStatus();
  await isUserAuthorized();
  await shouldRedirectToProfiler();
  await addOrgDataToNavbar();
  await initAnnunciFunebri();
  await initReferralLinks();
  try {
    await initSalesIqChat();
  } catch (err) {
    console.error(err);
  }

  initSidebarProfile();

  $('.editor-route').hide();
  $('#firstLoader').remove();

  $('#navbar-private').show();
  $('#navbar-canvas').hide();

  $('#navbar-private-button-back').hide();
  $('.logo').show();
};
